var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-3" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.resource("JourneyBuilder_TouchpointInfo_BrickName_Label")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _vm._v("\n                " + _vm._s(_vm.name) + "\n            ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-3" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.resource("JourneyBuilder_TouchpointInfo_BrickType_Label")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-9" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.typeName) + "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("touchpoint-info-connection-list", {
        staticClass: "form-group",
        attrs: {
          direction: _vm.resource(
            "JourneyBuilder_TouchpointInfo_Direction_Out"
          ),
          "connections-info": _vm.outgoingConnectionsInfo
        }
      }),
      _vm._v(" "),
      _c("touchpoint-info-connection-list", {
        staticClass: "form-group",
        attrs: {
          direction: _vm.resource("JourneyBuilder_TouchpointInfo_Direction_In"),
          "connections-info": _vm.incomingConnectionsInfo
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }